var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import { decode } from 'html-entities';
import PageHeader from '../../Components/Learn/PageHeader';
import Markdown from 'markdown-to-jsx';
import { extractExcerpt } from '../../Util/data';
import SocialShare from '../../Components/Learn/Share';
import StartupToolsCard from '../../Components/Learn/StartupToolsCard';
import displayToast from '../../Util/Toast';
const Article = ({ pageTitle, pageLink, pageShortTitle, childLink, childTitle, content, similarArticles, siteName, username }) => {
    const { t } = useTranslation();
    const copyShareLink = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (navigator.clipboard) {
            try {
                yield navigator.clipboard.writeText(window.location.href);
                displayToast(`<span class="material-icons">info</span><span>${t('proposalDetail.linkCopied')}</span>`, 'info', true);
            }
            catch (error) {
                displayToast((error === null || error === void 0 ? void 0 : error.message) || ((_a = error === null || error === void 0 ? void 0 : error.error) === null || _a === void 0 ? void 0 : _a.message) || 'Error', 'error');
            }
        }
    });
    const handleShareClick = (type) => {
        let shareUrl = null;
        switch (type) {
            case 'share':
                copyShareLink();
                break;
            case 'facebook':
                shareUrl = `https://www.facebook.com/sharer/sharer.php?title=${pageTitle}&description=${t('learn.articlePage.share.content').replace('%siteNameOrUsername%', siteName)}&u=${window.location.href}`;
                window.open(shareUrl);
                break;
            case 'linkedin':
                shareUrl = `https://www.linkedin.com/shareArticle?mini=true&url=${window.location.href}&refid=LinkedIn&title=${pageTitle}&text=${t('learn.articlePage.share.content').replace('%siteNameOrUsername%', siteName)}&source=LinkedIn&summary=${extractExcerpt(content)}`;
                window.open(shareUrl);
                break;
            case 'twitter':
                shareUrl = `https://twitter.com/share?text=${t('learn.articlePage.share.content').replace('%siteNameOrUsername%', username)}&url=${window.location.href}`;
                window.open(shareUrl);
                break;
        }
    };
    return (React.createElement("div", { className: "w-full bg-white" },
        React.createElement(PageHeader, { title: pageTitle, shortTitle: pageShortTitle, childLink: childLink, childTitle: childTitle, hasLink: true, link: pageLink }),
        React.createElement("section", { className: "md:pb-32 pb-24 px-6 w-full grid md:grid-cols-4 grid-cols-1" },
            React.createElement(Markdown, { className: "md:col-span-2 col-span-1 article prose max-w-184 mx-auto flex flex-col gap-6", options: { wrapper: 'article' } }, decode(content)),
            React.createElement("div", { className: "invisible" }),
            React.createElement("div", { className: "md:order-first" },
                React.createElement(SocialShare, { onShareClick: (type) => handleShareClick(type) }))),
        similarArticles.length > 0 && (React.createElement("section", { className: "bg-gray-50 w-full px-6 py-24" },
            React.createElement("div", { className: "w-full flex flex-col gap-16" },
                React.createElement("h2", { className: "md:text-[38px] text-3xl md:leading-10 leading-8 text-gray-800 font-semibold text-center" }, t('learn.moreArticles')),
                React.createElement("div", { className: "w-full max-w-(--breakpoint-2xl) mx-auto grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8" }, similarArticles
                    .slice(0, 3)
                    .map((article) => {
                    return (React.createElement(StartupToolsCard, Object.assign({ key: article.id }, article, { type: "subcategory" })));
                })))))));
};
export default Article;
